
const SearchResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	// "result": {}
		"searchKey": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		"originCityCode": 0,
		"destinationCityCode": 0,
		"pricedItineraries": [
			{
				"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				"isPassportMandatory": true,
				"railTripType": 0,
				"validating": "string",
				"fareSourceCode": "string",
				"netRate": 0,
				"currency": "string",
				"originDestinationOptions": [
					{
						"journeyDurationPerMinute": 0,
						"railSegments": [
							{
								"resBookDesigCode": "string",
								"class": "string",
								"departureDateTime": "string",
								"arrivalDateTime": "string",
								"stopQuantity": 0,
								"remainingCapacity": 0,
								"code": "string",
								"duration": "string",
								"durationPerMinute": 0,
								"departure": "string",
								"supplierDeparture": "string",
								"arrival": "string",
								"supplierArrival": "string",
								"vendingOperator": "string",
								"supplierVendingOperator": "string",
								"operator": "string",
								"supplierOperator": "string",
								"isReturn": true,
								"supplierRph": "string",
								"baggage": "string",
								"transferCode": "string",
								"imageURL": "string",
								"transferCompanyID": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
							}
						]
					}
				],
				"provider": 0,
				"providerOwner": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				"providerName": "string"
			}
		],
		"statusCode": 100
	
};
 

  export default SearchResponse;
  